import { render, staticRenderFns } from "./smallTitle.vue?vue&type=template&id=2664e59e&scoped=true"
import script from "./smallTitle.vue?vue&type=script&lang=js"
export * from "./smallTitle.vue?vue&type=script&lang=js"
import style0 from "./smallTitle.vue?vue&type=style&index=0&id=2664e59e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2664e59e",
  null
  
)

export default component.exports